import { useState } from "react";

export default function NewProgrammeModal({
  isOpen,
  onClose,
  onAdd
}) {

  

  const [programName, setProgramName] = useState("");

  const [degree, setDegree] = useState("BSc");

  const [applyUrl, setApplyUrl] = useState("");

  if (!isOpen) return null;

  return (

    <div className="admin-modal-overlay add-programme-modal-overlay">

      <div
        className="admin-modal add-programme-modal new-programme-modal"
        role="dialog"
        aria-modal="true"
        aria-labelledby="new-programme-title"
      >

        <div className="admin-modal-header">

          <h2 id="new-programme-title">New Programme</h2>

          <button
            type="button"
            className="admin-modal-close"
            onClick={onClose}
            aria-label="Close New Programme"
          >
            ×
          </button>

        </div>

        <div className="admin-modal-body">

          <div className="admin-form-group">

            <label>Programme Name</label>

            <input
                type="text"
                value={programName}
                onChange={(e) => setProgramName(e.target.value)}
                placeholder="Bachelor of Science in Cybersecurity"
            />

          </div>

          <div className="admin-form-group">

            <label>Degree</label>

            <select
                value={degree}
                onChange={(e) => setDegree(e.target.value)}
            >

              <option>BSc</option>

              <option>BA</option>

              <option>BEd</option>

              <option>LLB</option>

              <option>Dip</option>

              <option>HND</option>

              <option>MA</option>

              <option>MSc</option>

              <option>MBA</option>

              <option>MPhil</option>

              <option>PhD</option>

            </select>

          </div>

          <div className="admin-form-group">

            <label>Application URL</label>

            <input
                type="url"
                value={applyUrl}
                onChange={(e) => setApplyUrl(e.target.value)}
                placeholder="https://..."
            />

          </div>

        </div>

        <div className="admin-modal-footer">

          <button
            type="button"
            className="admin-secondary-btn"
            onClick={onClose}
          >
            Cancel
          </button>

          <button
            type="button"
            className="admin-primary-btn"
            onClick={() =>
              onAdd({
                program_name: programName,
                degree,
                apply_url: applyUrl
              })
            }
          >
            Add
          </button>

        </div>

      </div>

    </div>

  );

}
